import { render, staticRenderFns } from "./CartaoIcone.vue?vue&type=template&id=741ec514&scoped=true"
import script from "./CartaoIcone.vue?vue&type=script&lang=js"
export * from "./CartaoIcone.vue?vue&type=script&lang=js"
import style0 from "./CartaoIcone.vue?vue&type=style&index=0&id=741ec514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741ec514",
  null
  
)

export default component.exports